import _ from 'lodash';
import * as components from '../components';

const componentChild = {};
/**
 * 将./slots中的文件挂载到对象componentChild上
 * 文件名为key，对应JSON配置中的__config__.tag
 * 文件内容为value，解析JSON配置中的__slot__
 */
const slotsFiles = require.context('./slots', false, /\.js$/);
const keys = slotsFiles.keys() || [];
keys.forEach(key => {
  const tag = key.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = slotsFiles(key).default;
  componentChild[tag] = value;
});

function vModel (dataObject, defaultValue) {
  dataObject.props.value = defaultValue;

  dataObject.on.input = val => {
    this.$emit('input', val);
  };
}

function mountSlotFiles (h, confClone, children, formModel) {
  const childObjs = componentChild[confClone.__config__.tag];
  if (childObjs) {
    Object.keys(childObjs).forEach(key => {
      const childFunc = childObjs[key];
      if (confClone.__slot__ && confClone.__slot__[key]) {
        children.push(childFunc(h, confClone, key, formModel));
      }
    });
  }
}

function emitEvents (confClone) {
  ['on', 'nativeOn'].forEach(attr => {
    const eventKeyList = Object.keys(confClone[attr] || {});
    eventKeyList.forEach(key => {
      const val = confClone[attr][key];
      if (typeof val === 'string') {
        confClone[attr][key] = event => this.$emit(val, event);
      }
    });
  });
}

function buildDataObject (confClone, dataObject) {
  Object.keys(confClone).forEach(key => {
    const val = confClone[key];
    if (key === '__vModel__') {
      vModel.call(this, dataObject, confClone.__config__.defaultValue);
    } else if (dataObject[key] !== undefined) {
      if (dataObject[key] === null
        || dataObject[key] instanceof RegExp
        || ['boolean', 'string', 'number', 'function'].includes(typeof dataObject[key])) {
        dataObject[key] = val;
      } else if (Array.isArray(dataObject[key])) {
        if (key === 'class') {
          dataObject.attrs[key] = [...dataObject[key], ...val];
        }
        dataObject[key] = [...dataObject[key], ...val];
      } else {
        dataObject[key] = { ...dataObject[key], ...val };
      }
    } else {
      dataObject.attrs[key] = val;
    }
  });

  // 清理属性
  clearAttrs(dataObject);
}

function clearAttrs (dataObject) {
  delete dataObject.attrs.__config__;
  delete dataObject.attrs.__slot__;
  delete dataObject.attrs.__methods__;
}

function makeDataObject () {
  // 深入数据对象：
  // https://cn.vuejs.org/v2/guide/render-function.html#%E6%B7%B1%E5%85%A5%E6%95%B0%E6%8D%AE%E5%AF%B9%E8%B1%A1
  return {
    class: [],
    attrs: {},
    props: {},
    domProps: {},
    nativeOn: {},
    on: {},
    style: {},
    directives: [],
    scopedSlots: {},
    slot: null,
    key: null,
    ref: null,
    refInFor: true,
  };
}

export default {
  props: {
    conf: {
      type: Object,
      required: true,
    },
    mode: {
      // 预览模式 组件交互只能操作自由控件且在非继承节点
      // 渲染模式
      type: String,
      default: 'render',
      validator: function (val) {
        if (!val) return true;
        return ['preview', 'render'].indexOf(val) >= 0;
      },
    },
    formModel: Object,
  },
  components: {
    ...components,
  },
  render (h) {
    const dataObject = makeDataObject();
    const confClone = _.cloneDeep(this.conf);
    const children = this.$slots.default || [];
    // 如果slots文件夹存在与当前tag同名的文件，则执行文件中的代码
    mountSlotFiles.call(this, h, confClone, children, this.formModel);

    // 将字符串类型的事件，发送为消息
    emitEvents.call(this, confClone);
    // 将json表单配置转化为vue render可以识别的 “数据对象（dataObject）”
    buildDataObject.call(this, confClone, dataObject);

    if (this.mode === 'render') {
      dataObject.props['value'] = this.formModel[this.conf.__config__.renderKey];
      let config = this.conf.__config__;
      if (config.tag === 'el-select') {
        dataObject.on['clear'] = () => {
          this.$set(this.formModel, config.renderKey, this.conf.multiple ? [] : undefined);
        };
      }
      if (config.hasOwnProperty('filterParam')) {
        Object.keys(config.filterParam).forEach(prop => {
          let dependSource = config.filterParam[prop].source;
          if (dependSource && this.formModel[dependSource.key]) {
            dataObject.props[prop] = this.formModel[dependSource.key][`${dependSource.prop}`];
          }
        });
      }
    }
    // console.log(this.conf.__config__.tag, dataObject, confClone, 'confClone');
    return h(this.conf.__config__.tag, dataObject, children);
  },
};
